import { gql } from "@apollo/client";

export const GET_ORGANISATION_ADS = gql`
  query Ads($organisationId: ID!) {
    randomAd(organisationId: $organisationId) {
      id
      logo
      callToAction
      copy
      tag
      url
      bgColor
      callToActionColor
    }
  }
`;
